import { render, staticRenderFns } from "./productosComprados.vue?vue&type=template&id=d8c13b16&"
import script from "./productosComprados.vue?vue&type=script&lang=js&"
export * from "./productosComprados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports